(function () {
    'use strict';

    angular
        .module('social')
        .controller('SubscriptionController', SubscriptionController)

    SubscriptionController.$inject = ['subscriptions'];

    function SubscriptionController(subscriptions) {
        var vm = this;
        vm.subscriptions = subscriptions.length ? subscriptions : []
        console.log('subscriptions')
        console.log(vm.subscriptions)
    }
})();